var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCaretRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2556 47.0217L32.7715 75.5059C32.5069 75.7705 32.1927 75.9804 31.8469 76.1237C31.5011 76.2669 31.1305 76.3406 30.7562 76.3406C30.382 76.3406 30.0114 76.2669 29.6656 76.1237C29.3198 75.9804 29.0056 75.7705 28.741 75.5059C28.4763 75.2412 28.2664 74.927 28.1232 74.5812C27.98 74.2355 27.9062 73.8649 27.9063 73.4906C27.9062 73.1163 27.98 72.7457 28.1232 72.4C28.2664 72.0542 28.4763 71.74 28.741 71.4753L55.2134 45.0065L28.741 18.5376C28.2065 18.0031 27.9062 17.2782 27.9062 16.5224C27.9063 15.7665 28.2065 15.0416 28.741 14.5071C29.2755 13.9726 30.0004 13.6724 30.7562 13.6724C31.5121 13.6724 32.237 13.9726 32.7715 14.5071L61.2556 42.9912C61.5205 43.2558 61.7306 43.5699 61.8739 43.9157C62.0173 44.2615 62.091 44.6322 62.091 45.0065C62.091 45.3808 62.0173 45.7515 61.8739 46.0973C61.7306 46.443 61.5205 46.7572 61.2556 47.0217Z",
    fill: "#007FAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCaretRight);
export default __webpack_public_path__ + "static/media/blueCaretRight.2cb856b6a223cf0790088fd2614374d1.svg";
export { ForwardRef as ReactComponent };